export class UnreachableCaseError extends Error {
  constructor() {
    super(`Unreachable case`);
  }
}
